"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PROFILE: 'profile',
    HEXACO: 'hexaco',
    LESSON: 'lesson',
    PACKAGE: 'package',
};
//# sourceMappingURL=fileTagType.js.map